import React, { useState, useRef ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from './Header';
import api from '../api/api';

// Utility function to highlight text in dropdown options
const highlightText = (text = "", search = "") => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, "ig");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span
        key={i}
        className="bg-yellow-200 text-black font-semibold rounded px-0.5"
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

const DISPLAY_COLUMNS = [
  'Slno', 'Payer/Receiver', 'Creation time', 'Transaction ID',
  'Net amount', 'Status', 'Notes', 'Select', 'ReceiptStatus', 'Party', 'Clear'
];

const ReceiptUpload = ({ setIsLoggedIn }) => {
  const [data, setData] = useState([]);
  const [fileInfo, setFileInfo] = useState('No CSV file selected.');
  const [txnInput, setTxnInput] = useState('');
  const [partySelect, setPartySelect] = useState('');
  const [parties, setParties] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showAlloted, setShowAlloted] = useState(false);
  const fileInputRef = useRef(null);
  const [partySearch, setPartySearch] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const listRefParty = useRef(null);
  const [selectedVid, setSelectedVid] = useState('');
  const [activeIndexParty, setActiveIndexParty] = useState(-1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
//const [displayClicked, setDisplayClicked] = useState(false);
  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("lastVisited");
    setIsLoggedIn(false);
  };

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
      setActiveIndexParty(-1);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  // Auto scroll for party dropdown
  useEffect(() => {
    if (listRefParty.current && activeIndexParty >= 0) {
      const item = listRefParty.current.children[activeIndexParty];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexParty]);
  const formatCurrency = (val) => {
    if (!val) return '';
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(val);
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
  };

  const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setFileInfo('Uploading...');

  const reader = new FileReader();
  reader.onload = async () => {

    // ✅ Safe CSV parsing (handles commas inside quotes)
    const rows = reader.result
      .split(/\r?\n/)
      .filter(r => r.trim() !== '');

    const headers = rows[0]
      .match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g)
      .map(h => h.replace(/^"|"$/g, ''));

    const records = rows.slice(1).map(row => {
      const values = row
        .match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g)
        .map(v => v.replace(/^"|"$/g, ''));

      const obj = {};
      headers.forEach((h, i) => obj[h] = values[i] ?? '');

      return {
        PayerReceiver: obj['Payer/Receiver'] || '',
        Paidvia: 'Google Pay',
        Type: 'UPI',
        Creationtime: obj['Creation time'] || '',
        TransactionID: obj['Transaction ID'] || '',
        Amount: obj['Net amount'] || '0',
        Processingfee: '0',
        Netamount: obj['Net amount'] || '0',
        Status: obj['Status'] || '',
        Updatetime: obj['Creation time'] || '',
        Notes: obj['Notes'] || ''   // ✅ Now this will work even with commas
      };
    });

    const user = sessionStorage.getItem('username') || 'admin';

    try {
      await api.GpaylogAPI({ user, Items: records });
      setFileInfo(`Uploaded: ${file.name} (${records.length} records inserted)`);
      showMessage('success', `Successfully inserted ${records.length} records`);
    } catch (error) {
      console.error(error);
      setFileInfo('Upload failed');
      showMessage('error', 'Failed to insert records');
    }
  };

  reader.readAsText(file);
};


  const toggleRow = (index, checked) => {
  const updatedData = data.map((row, i) => ({
    ...row,
    ui_selected: i === index ? checked : false
  }));

  setData(updatedData);

  // Show only the selected row's transaction id
  const selectedRow = updatedData.find(r => r.ui_selected);
  setTxnInput(selectedRow ? selectedRow['Transaction ID'] : '');
};

  const bindParty = () => {
    const party = partySelect;
    let count = 0;
    const newData = data.map(r => {
      if (r.ui_selected) {
        r.ui_party = party;
        r.vid = selectedVid;
        r.ui_receiptStatus = "Alloted";
        r.ui_selected = false;
        count++;
      }
      return r;
    });
    setData(newData);
    setTxnInput('');
    showMessage("success", `Bound ${party} to ${count} rows`);
  };

  const clearRow = (i) => {
    const newData = [...data];
    newData[i].ui_selected = false;
    newData[i].ui_party = "";
    newData[i].ui_receiptStatus = "Pending";
    setData(newData);
    setTxnInput('');
  };

  const generateReceipt = async () => {
    if (!data.length) {
      showMessage("error", "No data to generate receipt");
      return;
    }

    const user = sessionStorage.getItem('username') || 'admin';
    const items = data.map((row, index) => ({
      Slno: (index + 1).toString(),
      PayerReceiver: row['Payer/Receiver'] || '',
      Paidvia: row.Paidvia || 'Google Pay',
      Type: row.Type || 'UPI',
      Creationtime: row['Creation time'] || '',
      TransactionID: row['Transaction ID'] || '',
      Amount: row.Amount || '0.00',
      Processingfee: row.Processingfee || '0.00',
      Netamount: row.Netamount || '0.00',
      Status: row.Status || '',
      Updatetime: row.Updatetime || '',
      Notes: row.Notes || '',
      vid: row.vid || '0',
      RecStatus: row.ui_receiptStatus || 'Pending',
      vname: row.ui_party || ''
    }));

    try {
      await api.SaveUPIPaymentAPI({ USERNAME: user, Sessid: "0", Items: items });
      showMessage("success", `Generated receipt for ${data.length} rows`);
      navigate('/dashboard');
    } catch (error) {
      console.error(error);
      showMessage("error", "Failed to generate receipt");
    }
  };

  const handleDisplay = async () => {
  //    if (displayClicked) return;   

  // setDisplayClicked(true); 
    const user = sessionStorage.getItem('username') || 'admin';
    try {
      const response = await api.GetUpiPaymentListAPI({ user, ShowAllotedListAlso: showAlloted ? "1" : "0" });
      const table = response.GetUpiPaymentListAPIjs.Table;
      const table1 = response.GetUpiPaymentListAPIjs.Table1 || [];
      const mappedData = table.map(item => ({
        ...item,
        'Payer/Receiver': item.PayerReceiver,
        'Creation time': item.Creationtime,
        'Transaction ID': item.TransactionID,
        'Net amount': item.Netamount,
        'Status': item.Status,
        'Notes': item.Notes,
        ui_selected: false,
        ui_receiptStatus: item.RecStatus,
        ui_party: item.vname || " "
      }));
      setData(mappedData);
      setParties(table1);
      setFileInfo(`Displayed ${mappedData.length} records`);
      showMessage('success', `Loaded ${mappedData.length} records`);
    } catch (error) {
      console.error(error);
      showMessage('error', 'Failed to load records');
    }
  };

  const updateNotes = (index, value) => {
    const newData = [...data];
    newData[index]['Notes'] = value;
    setData(newData);
  };

  const handleKeyDownParty = (e) => {
    const options = filteredParties;
    if (!isDropdownOpen && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setIsDropdownOpen(true);
      setActiveIndexParty(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexParty(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexParty(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (isDropdownOpen && activeIndexParty >= 0) {
          e.preventDefault();
          const selected = options[activeIndexParty];
          if (selected) {
            setPartySelect(selected.PartyRef);
            setSelectedVid(selected.vid);
            setPartySearch('');
            setIsDropdownOpen(false);
            setActiveIndexParty(-1);
          }
        }
        break;
      case "Escape":
        setIsDropdownOpen(false);
        setActiveIndexParty(-1);
        break;
      default:
        break;
    }
  };

  const mockSave = () => showMessage("info", "Mock save complete");
  const mockClose = () => showMessage("info", "Mock close action");

  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export.");
      return;
    }

    // Define CSV headers based on DISPLAY_COLUMNS
    const headers = DISPLAY_COLUMNS.map(col => col);

    // Map data to CSV rows
    const csvRows = filteredData.map(row =>
      DISPLAY_COLUMNS.map(col => {
        switch (col) {
          case 'Slno': return row.id || '';
          case 'Payer/Receiver': return row['Payer/Receiver'] || '';
          case 'Creation time': return row['Creation time'] || '';
          case 'Transaction ID': return row['Transaction ID'] || '';
          case 'Net amount': return row['Net amount'] || '';
          case 'Status': return row.Status || '';
          case 'Notes': return row.Notes || '';
          case 'Select': return ''; // Skip checkbox
          case 'ReceiptStatus': return row.ui_receiptStatus || '';
          case 'Party': return row.ui_party || '';
          case 'Clear': return ''; // Skip button
          default: return row[col] || '';
        }
      })
    );

    // Combine headers and rows
    const csvContent = [headers, ...csvRows]
      .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
      .join("\n");

    // Create and download the file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `receipts_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
const filteredParties = parties.filter(p =>
  p.PartyRef.toLowerCase().includes(partySearch.toLowerCase())
);

const filteredData = data.filter(row =>
  (row['Payer/Receiver'] || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (row['Transaction ID'] || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (row.Status || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (row.Notes || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (row.ui_receiptStatus || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (row.ui_party || '').toLowerCase().includes(searchTerm.toLowerCase())
);
  return (
    <div className="min-h-screen bg-gray-50">
      <Header onLogout={handleLogout} />
      <main className="p-2 sm:p-5 md:ml-64">
       <header className="mb-2 flex items-center relative">
  <button
    onClick={() => navigate('/dashboard')}
    className="inline-flex items-center gap-1 px-3 py-1 text-gray-800 font-semibold
      bg-gray-200 hover:bg-gray-300 rounded-full shadow transition
      text-sm sm:text-base"
  >
    ← Back
  </button>
  <h1 className="absolute left-1/2 -translate-x-1/2 text-2xl font-extrabold text-orange-500 tracking-tight">
    Receipt Upload
  </h1>
  <div className="ml-auto flex space-x-3">
   
  </div>

</header>
        <div className="bg-white shadow-xl rounded-xl p-4 border-t-4 border-orange-600 mb-3">
         <div className="flex flex-wrap items-center gap-3 pb-2 border-b mb-3">

  {/* Browse */}
  <label className="cursor-pointer px-3 py-1.5 bg-blue-600 text-white text-sm font-semibold rounded-md hover:bg-blue-700 transition">
    Browse…
    <input
      type="file"
      accept=".csv"
      onChange={handleFileUpload}
      hidden
      ref={fileInputRef}
    />
  </label>

  {/* File info */}
  <div className="text-gray-500 italic text-sm min-w-[180px] truncate">
    {fileInfo}
  </div>

  {/* Upload */}
  {/* <button
    type="button"
    className="px-3 py-1.5 bg-orange-500 text-white text-sm font-semibold rounded-md hover:bg-orange-600 transition"
  >
    Upload
  </button> */}

  {/* Display */}
  <button
    type="button"
    onClick={handleDisplay}
    className="px-3 py-1.5 bg-orange-500 text-white text-sm font-semibold rounded-md hover:bg-orange-600 transition"
  >
    Display
  </button>

  {/* <button
  type="button"
  onClick={handleDisplay}
  disabled={displayClicked}
  className={`px-3 py-1.5 text-sm font-semibold rounded-md transition
    ${displayClicked
      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
      : "bg-orange-500 text-white hover:bg-orange-600"}`}
>
  Display
</button> */}

  {/* Checkbox */}
  <label className="flex items-center gap-2 block text-sm font-medium text-gray-700 cursor-pointer select-none">
    <input
      type="checkbox"
      checked={showAlloted}
      onChange={(e) => setShowAlloted(e.target.checked)}
      className="w-4 h-4 accent-orange-500"
    />
    Show Alloted List
  </label>

</div>


         <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-4 gap-2 items-end">

  {/* Transaction ID */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Transaction ID
    </label>
    <input
      value={txnInput}
      readOnly
      className="w-full border rounded-lg p-2 bg-gray-50 font-mono text-sm"
    />
  </div>

  {/* Customer (wider) */}
  {/* <div className="lg:col-span-2">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Customer
    </label>
    <select
      value={partySelect}
      onChange={(e) => setPartySelect(e.target.value)}
      className="w-full border rounded-lg p-2 text-sm"
    >
      {parties.map(party => (
        <option key={party}>{party}</option>
      ))}
    </select>
  </div> */}
<div ref={dropdownRef} className="lg:col-span-2">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Customer
  </label>

  <div className="relative">
   <input
   type="text"
   value={partySearch || partySelect}
   onFocus={() => setIsDropdownOpen(true)}
   onClick={() => setIsDropdownOpen(true)}
   onChange={(e) => {
     setPartySearch(e.target.value);
     setPartySelect('');
     setSelectedVid('');
     setIsDropdownOpen(true);
     setActiveIndexParty(-1);
   }}
   onKeyDown={handleKeyDownParty}
   placeholder="Select or search customer..."
   className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-orange-400 outline-none"
 />

   {isDropdownOpen && (
      <div ref={listRefParty} className="absolute z-20 mt-1 w-full max-h-44 overflow-y-auto border rounded-lg bg-white shadow-lg">
       {filteredParties.length > 0 ? (
 filteredParties.map((party, index) => (
   <div
     key={party.PartyRef}
     onClick={() => {
       setPartySelect(party.PartyRef);
       setSelectedVid(party.vid);
       setPartySearch('');
       setIsDropdownOpen(false);
       setActiveIndexParty(-1);
     }}
     onMouseEnter={() => setActiveIndexParty(index)}
     className={`px-3 py-2 text-sm cursor-pointer ${
       index === activeIndexParty
         ? "bg-gray-100 font-semibold"
         : "hover:bg-orange-100"
     }`}
   >
     {highlightText(party.PartyRef, partySearch)}
   </div>
 ))
) : (
 partySearch && (
   <div className="px-3 py-2 text-sm text-gray-400 italic">
     No matching customers
   </div>
 )
)}
      </div>
    )}
  </div>
</div>


  {/* Buttons */}
  <div className="flex gap-2 lg:col-span-1">
    <button
      onClick={bindParty}
      className="px-3 py-2 text-sm bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition"
    >
      Apply
    </button>

    <button
      onClick={generateReceipt}
      className="px-3 py-1.5 text-sm bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition"
    >
      Generate
    </button>
        <button onClick={exportToCSV} className="px-2 py-1 font-semibold inline-flex w-auto self-start text-white bg-blue-500 hover:bg-blue-700 rounded-full shadow transition"
        >
       📄 Export
    </button>
  </div>

</div>


          {message.text && (
            <div className={`mt-4 p-3 rounded-lg ${message.type === 'success' ? 'bg-green-100 text-green-700' : message.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
              {message.text}
            </div>
          )}
        </div>

        <div className="bg-white shadow-xl rounded-xl p-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3">
  <h2 className="text-base font-semibold text-gray-700">
    Transaction Details
  </h2>

  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder="🔍 Search by Payer/Receiver, Transaction ID, Status, Notes, ReceiptStatus, Party"
    className="px-3 py-2 w-full md:w-72 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400"
  />
</div>
         

          <div className="overflow-x-auto shadow-xl rounded-lg border">
            <table className="min-w-full divide-y divide-orange-200">
              <thead className="bg-orange-50">
                <tr>
                  {DISPLAY_COLUMNS.map(col => (
                    <th key={col} className="px-2 py-1 text-xs font-bold text-orange-800 whitespace-nowrap">{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y">
                {filteredData.map((row, filteredIndex) => {
                  const originalIndex = data.indexOf(row);
                  return (
                    <tr key={originalIndex} className={row.ui_selected ? "bg-orange-100 border-l-4 border-orange-500" : ""}>
                      {DISPLAY_COLUMNS.map(col => {
                        let content = '';
                        let className = "px-1 py-1 text-sm";
                        switch (col) {
                          case 'Slno': content = filteredIndex + 1; break;
                          case 'Net amount': content = formatCurrency(row['Net amount']); className += " text-right"; break;
                          case 'Select':
                            content = <input type="checkbox" checked={row.ui_selected} onChange={(e) => toggleRow(originalIndex, e.target.checked)} />;
                            break;
                          // case 'ReceiptStatus':
                          //   content = <span className="px-3 py-1 rounded-full text-xs bg-orange-100">{row.ui_receiptStatus}</span>;
                          //   break;
                          case 'ReceiptStatus':
  content = (
    <div className="flex justify-center">
      <span className="min-w-[80px] text-center px-3 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-800">
        {row.ui_receiptStatus}
      </span>
    </div>
  );
  break;
                          case 'Party': content = row.ui_party; break;
                          case 'Clear':
                            content = <button onClick={() => clearRow(originalIndex)} className="text-red-600">✖</button>;
                            break;
                          case 'Notes':
                            content = <input value={row[col] || ''} onChange={(e) => updateNotes(originalIndex, e.target.value)}
                            className="w-full min-w-[140px] border rounded px-2 py-1.5 text-xs"/>;
                            break;
                          default:
                            content = row[col] || '';
                        }
                        return <td key={col} className={className}>{content}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReceiptUpload;